import clsx from 'clsx';

import type { DateInput } from '@repo/common';
import { SDSPrimitiveButton } from '@repo/sds/SDSPrimitiveButton';
import { SDSText } from '@repo/sds/SDSText';

import './YearlyCalendarMonthDay.scss';

interface YearlyCalendarMonthDayProps {
  month: DateInput;
  monthLabel: string;
  isSelected: boolean;
  isCurrentMonth: boolean;
  onClick: () => void;
}

export function YearlyCalendarMonthDay({
  month,
  monthLabel,
  isSelected,
  isCurrentMonth,
  onClick,
}: YearlyCalendarMonthDayProps) {
  const rootClassName = clsx('YearlyCalendarMonthDay', {
    'YearlyCalendarMonthDay--selected': isSelected,
    'YearlyCalendarMonthDay--current-month': isCurrentMonth,
  });

  return (
    <SDSPrimitiveButton
      className={rootClassName}
      onClick={onClick}
      ariaLabel={`${monthLabel} ${new Date(month).getFullYear()}`}
      ariaPressed={isSelected}
    >
      <SDSText
        type={isSelected ? 'body-large-bold' : 'body-large'}
        text={monthLabel}
        className="YearlyCalendarMonthDay__label"
      />
    </SDSPrimitiveButton>
  );
}
